export const AUTH_PATH_CONSTANTS = {
  BASE_URL: '/',
  MVP_CHARTS: 'mvp/charts',
  REPORTS: 'mvp/reports',
  ARCHIEVED: 'mvp/archieved',
  FIELD_REPORT: 'mvp/createReport',
  REPORT_DETAILS_MOBILE: 'mvp/reportDetails',
};

const DEFAULT_REDIRECTION_URL =
  '/' + AUTH_PATH_CONSTANTS.MVP_CHARTS;

const getPathName = (urlString: string): string => {
  // Split by "?" (query) or "#" (hash) and get the path part
  const [path] = urlString.split(/[?#]/);
  return path;
};

export const getValidRedirectionUrl = (url?: string) => {
  let screen_url =
    url || localStorage.getItem('screen_url');
  if (!screen_url) {
    return DEFAULT_REDIRECTION_URL;
  }
  if (screen_url[0] !== '/') {
    screen_url = '/' + screen_url;
  }
  const pathName = getPathName(screen_url);
  if (
    Object.values(AUTH_PATH_CONSTANTS).find(
      (value) => '/' + value === pathName
    )
  ) {
    return screen_url;
  } else {
    return DEFAULT_REDIRECTION_URL;
  }
};

export const setScreenUrlToLoacalStorage = (
  screen_url?: string | null | undefined
) => {
  const windowLocation = window.location;
  const url =
    screen_url ||
    windowLocation.href.replace(windowLocation.origin, '');
  if (url) {
    const validRedirectionUrl = getValidRedirectionUrl(url);
    localStorage.setItem('screen_url', validRedirectionUrl);
  }
};
